import { useState, useEffect } from 'react';

const WHATSAPP_URL = 'https://wa.me/903222286464';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Ürünler', href: '#urunler' },
    { label: 'Özel Baskı', href: '#ozel-baski' },
    { label: 'Neden Biz', href: '#neden-biz' },
    { label: 'Mağaza', href: '#magaza' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/785265ea-7d68-45e2-baa3-c310ca661c92.png"
            alt="Logo"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-white/80 hover:text-[#FF4500] transition-colors text-sm font-semibold tracking-wide uppercase cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Desktop CTA */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white px-5 py-2.5 rounded-full text-sm font-bold transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-base w-4 h-4 flex items-center justify-center" />
          WhatsApp'tan Yaz
        </a>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-white cursor-pointer"
          aria-label="Menüyü aç"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-sm border-t border-white/10 px-4 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/80 hover:text-[#FF4500] transition-colors text-base font-semibold uppercase cursor-pointer py-1"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full text-sm font-bold mt-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            WhatsApp'tan Yaz
          </a>
        </div>
      )}
    </nav>
  );
}
